import { createFileRoute } from "@tanstack/react-router";
import { Dashboard } from "#app/widgets/dashboards/dashboard";
import { WidgetsGate } from "#app/widgets/dashboards/widgets-gate";

/**
 * `/team/$teamId/dashboard` — the team dashboard, scoped to one team.
 * Feature-flagged behind WIDGETS; navigating here with the flag off redirects
 * to the board (the tab is hidden in that case anyway). Flags resolve async,
 * so hold on a spinner until `ready` — deciding early would bounce flag-on
 * users to the board on a fresh load.
 */
function TeamDashboardRoute() {
  const { workspace, teamId } = Route.useParams();
  return (
    <WidgetsGate redirectTo={`/${workspace}/team/${teamId}/board`}>
      <Dashboard scope={{ kind: "team", teamId }} />
    </WidgetsGate>
  );
}

export const Route = createFileRoute("/(app)/$workspace/team/$teamId/dashboard")({
  component: TeamDashboardRoute,
});
